var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Convert SSH Key to PPK format ")]
          ),
          _c(
            "v-card-text",
            [
              !_vm.ppk
                ? [
                    _c("p", [
                      _vm._v(
                        "Enter the passphrase to unlock the “" +
                          _vm._s(_vm.sshKey.name) +
                          "” key for conversion:"
                      )
                    ]),
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        label: "Passphrase",
                        name: "Passphrase",
                        "error-messages": _vm.errors.collect("Passphrase")
                      },
                      model: {
                        value: _vm.pass,
                        callback: function callback($$v) {
                          _vm.pass = $$v
                        },
                        expression: "pass"
                      }
                    })
                  ]
                : [
                    _c("p", [
                      _vm._v(
                        "Convert the “" +
                          _vm._s(_vm.sshKey.name) +
                          "” key to PPK format:"
                      )
                    ]),
                    _c("v-textarea", {
                      attrs: {
                        outlined: "",
                        rows: "7",
                        readonly: "",
                        value: _vm.ppk
                      }
                    })
                  ]
            ],
            2
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "pt-0 justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0 ml-0",
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              !_vm.ppk
                ? _c(
                    "gg-btn",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.convert
                      }
                    },
                    [_vm._v(" Convert ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }